export const REGION = "australia-southeast1";

// local
export const LOCAL_USER = "Local User";

// ref
export const REF = {
  GROUP: "group",
  SERVICE: "service",
  BOOKING: "booking",
  BRANCH: "branch",
  CONSULTATION: "consultation",
};

// API
export const API = {
  ZOHO_SYNC_INFO: "api-zoho-sync-info",
};
